import { Component, inject, OnInit, signal } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatFormField, MatHint, MatLabel } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { MatListOption, MatSelectionList } from '@angular/material/list';
import { userDtos, webDtos } from '@vectronic/openApi-customer';
import { ItemToCustomerWebDto, MemberItem } from '@vectronic/util';
import { CardComponent } from '../../components/card/card.component';
import { sortbyOrderAscending } from '../../utils/util.sort';

@Component({
  selector: 'vectronic-create-group',
  templateUrl: './create-group.component.html',
  styleUrls: ['./create-group.component.scss'],
  imports: [
    CardComponent,
    ReactiveFormsModule,
    MatDialogContent,
    MatFormField,
    MatLabel,
    MatInput,
    MatHint,
    MatSelectionList,
    MatListOption,
    MatDialogActions,
    MatButton,
    MatIcon,
  ],
})
export class CreateGroupComponent implements OnInit {
  createGroupForm: FormGroup;
  private fb = inject(FormBuilder);
  dialogRef = inject(MatDialogRef<CreateGroupComponent>);
  data: {
    items: ItemToCustomerWebDto<MemberItem>[];
    selectedItemsIds: number[];
  } = inject(MAT_DIALOG_DATA);
  result: { group: userDtos.Group; selectedItemsIds: number[] };

  filteredItems = signal<ItemToCustomerWebDto<MemberItem>[]>([]);

  ngOnInit() {
    this.filteredItems.set(
      this.data.items
        .filter((item: webDtos.AnimalExtended) => !item.accessOnlyFromCollar)
        .toSorted(sortbyOrderAscending),
    );
    this.createGroupForm = this.fb.group({
      name: ['', Validators.required],
      label: [''],
      description: [''],
      selectedItemsIds: [this.data.selectedItemsIds, Validators.required],
    });
  }

  cancel() {
    this.dialogRef.close({
      selectedItemsIds: this.createGroupForm.get('selectedItemsIds')?.value,
    });
  }

  apply() {
    if (this.createGroupForm.valid) {
      const newGroup: userDtos.Group = {
        id: null,
        name: this.createGroupForm.get('name')?.value,
        label: this.createGroupForm.get('label')?.value,
        membersIds: this.createGroupForm.get('selectedItemsIds')?.value,
        description: this.createGroupForm.get('description')?.value,
      };
      this.dialogRef.close({ group: newGroup });
    }
  }
}
